// import { Button, DatePicker, Form, Input, Modal } from "antd";
// import moment from "moment";
// import { useState } from "react";
// import { Col, Row } from "react-bootstrap";

// const PauseResumeModal = ({
//   isModalOpen,
//   handleCancel,
//   data,
//   onSubmit,
//   holdResume,
//   isLoading,
// }: any) => {
//   const [from, setFrom] = useState<moment.Moment | null>(moment());
//   const [to, setTo] = useState<moment.Moment | null>(moment().add(1, "day"));
//   const [days, setDays] = useState<number>(1);

//   const submit = () => {
//     onSubmit(from, to, days);
//   };

//   return (
//     <Modal
//       open={isModalOpen}
//       onCancel={handleCancel}
//       footer={null}
//       centered
//       closeIcon={false}
//     >
//       <h5 className="user-heading">
//         {holdResume?.id ? "Resume" : "Pause"} Subscription
//       </h5>
//       <Form layout="vertical" onFinish={submit} hideRequiredMark>
//         {!holdResume ? (
//           <>
//             <Form.Item label="Hold From" required>
//               <DatePicker
//                 className="w-100"
//                 value={from}
//                 onChange={(date) => {
//                   setFrom(date);
//                   setTo(date ? date.clone().add(1, "day") : null);
//                 }}
//                 disabledDate={(current: any) =>
//                   current &&
//                   moment(current).isAfter(moment(data?.end_date), "day")
//                 }
//               />
//             </Form.Item>
//             <Form.Item label="Resume On" required>
//               <DatePicker
//                 className="w-100"
//                 value={to}
//                 onChange={setTo}
//                 disabledDate={(current: any) =>
//                   from ? moment(current).isSameOrBefore(from, "day") : false
//                 }
//               />
//             </Form.Item>
//             <Form.Item label="Total Number of Days">
//               <Input
//                 type="number"
//                 value={days}
//                 onChange={(e) => {
//                   const val = Number(e.target.value);
//                   setDays(val);
//                   setTo(from?.clone().add(val, "days") || null);
//                 }}
//               />
//             </Form.Item>
//           </>
//         ) : (
//           <div className="p-2">
//             <p>
//               Subscription Expiry:
//               {moment(holdResume?.current_exp).format("YYYY/MM/DD")}
//             </p>
//             <p>
//               Hold Period:
//               {`${moment(holdResume?.hold_from).format(
//                 "YYYY/MM/DD"
//               )} to ${moment(holdResume?.hold_to).format("YYYY/MM/DD")}`}
//             </p>
//             <p>
//               Extended Expiry:
//               {moment(holdResume?.current_exp)
//                 .add(Number(holdResume?.num_days), "days")
//                 .format("YYYY/MM/DD")}
//             </p>
//             <p>
//               No. days: {holdResume?.num_days} day
//               {holdResume?.num_days > 1 ? "s" : null}
//             </p>
//           </div>
//         )}
//         <Row>
//           <Col md={5}></Col>
//           <Col md={7}>
//             <div className="d-flex gap-2">
//               <Button block onClick={handleCancel}>
//                 Close
//               </Button>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 block
//                 loading={isLoading}
//               >
//                 {holdResume?.id ? "Resume Now" : "Pause Now"}
//               </Button>
//             </div>
//           </Col>
//         </Row>
//       </Form>
//     </Modal>
//   );
// };

// export default PauseResumeModal;

import React, { useState, useEffect } from "react";
import { Modal, DatePicker, Input, Button, Space, Descriptions } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

interface HoldResumeType {
  id?: string;
  current_exp: string;
  hold_from: string;
  hold_to: string;
  num_days: number;
}

interface UserData {
  user: {
    id: string;
  };
  end_date: string;
}

interface PauseResumeModalProps {
  data: UserData;
  isModalOpen: boolean;
  handleCancel: () => void;
  onSubmit: (from: Dayjs, to: Dayjs, days: number) => void;
  holdResume?: HoldResumeType;
  isLoading: boolean;
  isPaused: boolean;
}

const PauseResumeModal: React.FC<PauseResumeModalProps> = ({
  data,
  isModalOpen,
  handleCancel,
  onSubmit,
  holdResume,
  isLoading,
  isPaused,
}) => {
  const [from, setFrom] = useState<Dayjs>(dayjs());
  const [to, setTo] = useState<Dayjs>(dayjs().add(1, "day"));
  const [days, setDays] = useState<number>(1);

  // Reset dates when modal opens
  useEffect(() => {
    if (isModalOpen && !isPaused) {
      setFrom(dayjs());
      setTo(dayjs().add(1, "day"));
      setDays(1);
    }
  }, [isModalOpen, isPaused]);

  useEffect(() => {
    if (from && to) {
      const diffDays = to.startOf("day").diff(from.startOf("day"), "day");
      setDays(diffDays || 1);
    }
  }, [from, to]);

  const handleFromChange = (date: Dayjs | null) => {
    if (date) {
      setFrom(date);
      setTo(date.add(1, "day"));
    }
  };

  const handleToChange = (date: Dayjs | null) => {
    if (date) {
      setTo(date);
    }
  };

  const handleDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDays = parseInt(e.target.value) || 1;
    setDays(newDays);
    if (from) {
      setTo(from.add(newDays, "day"));
    }
  };

  const handleSubmit = () => {
    onSubmit(from, to, days);
  };

  const disabledFromDate = (current: Dayjs) => {
    return current && current < dayjs().startOf("day");
  };

  const disabledToDate = (current: Dayjs) => {
    return current && current <= from;
  };

  return (
    <Modal
      title={`${isPaused ? "Resume" : "Pause"} Subscription`}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={isLoading}
          onClick={handleSubmit}
          disabled={!isPaused && days < 1}
        >
          {isPaused ? "Resume Now" : "Pause Now"}
        </Button>,
      ]}
    >
      {isPaused && holdResume ? (
        <Descriptions column={1}>
          <Descriptions.Item label="Sub. Expiry Date">
            {holdResume?.current_exp
              ? dayjs(holdResume?.current_exp).format("YYYY/MM/DD")
              : ""}
          </Descriptions.Item>
          <Descriptions.Item label="Hold Period">
            {dayjs(holdResume.hold_from).format("YYYY/MM/DD")} -{" "}
            {dayjs(holdResume.hold_to).format("YYYY/MM/DD")}
          </Descriptions.Item>
          <Descriptions.Item label="Extended Expiry Date">
            {holdResume.current_exp
              ? dayjs(holdResume.current_exp)
                  .add(holdResume.num_days, "day")
                  .format("YYYY/MM/DD")
              : ""}
          </Descriptions.Item>
          <Descriptions.Item label="No. days">
            {holdResume.num_days} day{holdResume.num_days > 1 ? "s" : ""}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <div>
            <div style={{ marginBottom: 8 }}>Hold on</div>
            <DatePicker
              value={from}
              onChange={handleFromChange}
              disabledDate={disabledFromDate}
              style={{ width: "100%" }}
              format="YYYY/MM/DD"
            />
          </div>
          <div>
            <div style={{ marginBottom: 8 }}>Resume on</div>
            <DatePicker
              value={to}
              onChange={handleToChange}
              disabledDate={disabledToDate}
              style={{ width: "100%" }}
              format="YYYY/MM/DD"
            />
          </div>
          <div>
            <div style={{ marginBottom: 8 }}>Total Number of days</div>
            <Input
              type="number"
              value={days}
              onChange={handleDaysChange}
              min={1}
            />
          </div>
        </Space>
      )}
    </Modal>
  );
};

export default PauseResumeModal;
